import { Component, ElementRef, OnDestroy, AfterViewInit, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AddressBookDto } from '@cradua/data';
import { fromEvent, Observable, of, Subscription } from 'rxjs';
import { concatMap, debounceTime, distinctUntilChanged, map, pluck, withLatestFrom } from 'rxjs/operators';

import { AcquisitionGenericFacade } from '../../state/+acquisition-generic/acquisition-generic.facade';

@Component({
  selector: 'cradua-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("search", { static: true }) searchForm: ElementRef;
  @Output() emitTask = new EventEmitter<any>();
  isLoadingAddressBook$: Observable<boolean>;
  addressBook$: Observable<AddressBookDto[]>;

  searchSubscription$: Subscription;
  searchedAddressBook: AddressBookDto[];
  listView = false;
  gridView = true;

  constructor(
    public dialogRef: MatDialogRef<SearchModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private acquisitionGenericFacade: AcquisitionGenericFacade,
  ) { }

  ngOnInit(): void {

    this.isLoadingAddressBook$ = this.acquisitionGenericFacade.isLoadingAcquisitionGenericWithoutId('AddressBook');
    this.addressBook$ = this.acquisitionGenericFacade.loadGatewayWithoutId('AddressBook');
  }

  ngAfterViewInit(): void {
    this.searchSubscription$ = fromEvent(this.searchForm.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        pluck("target", "value"),
        // tap(_ =>  this.emitTask.emit('list')),
        // filter((searchTerm: string) => searchTerm.length > 2),
        map(value => value),
        concatMap((value: string) => {
         return of(value).pipe(
            withLatestFrom(this.addressBook$)
          )
        })
      ).subscribe(([query, data]) => {
          query ?
          this.searchedAddressBook = data.filter(item => item.Name && item.Name.toLowerCase().includes(query.toLowerCase())) :
             this.searchedAddressBook = [];
      });
  }

  OnChange(event) {
    if(event.checked) {
      this.addressBook$.subscribe(data => {
        this.searchedAddressBook = data;
      })
    }else {
      this.searchedAddressBook = [];
    }
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  createAddressBook() {
  const data = {
    selectedIndex: 7,
    event: 'create',
    type: 'addressBook'
    }
    this.dialogRef.close(data);
  }

  onView(value: AddressBookDto) {
    const data = {
      type: 'searchAddressBook',
      ...value
    }
    this.dialogRef.close(data);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.searchSubscription$) {
      this.searchSubscription$.unsubscribe();
    }
  }


}
